import { ENTER, COMMA, E } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { SocialHistoryModel } from 'app/EMR/HistoryModels/social_history.model';
import { Observable, Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-social-history',
  templateUrl: './social-history.component.html',
  styleUrls: ['./social-history.component.scss']
})
export class SocialHistoryComponent implements OnInit {
  private socialHistroy: any = [];
  private filteredsocialHistroy: Observable<SocialHistoryModel[]>;
  private socialHistroyCtrl = new FormControl('');
  private destroysocial$: Subject<boolean> = new Subject<boolean>();
  private chipInput: any;
  private selectable = true;
  private removable = true;
  private allsocialHistroy: any;
  private separatorKeysCodes: number[] = [ENTER, COMMA];
  private filterData: any;
  private filterDatlist: any;
  private selectedVal: any;
  private addhabitname: string = '';
  private enabledisablebtn: boolean = false;
  constructor(private emrservice: EMRService, private dashboardService: DashboardService) {
   
  }

  ngOnInit(): void {
    let getSocialHistorylist = this.emrservice.otherinfo_history.socailHistory;
    if (getSocialHistorylist != null) {
      let socialchipdata = getSocialHistorylist.split(',');
      this.socialHistroy = socialchipdata;
      this.selectedVal = this.socialHistroy;
    }
    this.enabledisablebtn = true;
    this.addhabitname = '';
   // this.get_otherinfo();
   this.getSocialHistoryList();
  }
  
  getSocialHistoryList() {

    this.emrservice.getSocialHistory().pipe(takeUntil(this.destroysocial$)).subscribe(data => {
      this.filterDatlist = data;
      if (this.socialHistroy.length != 0) {
        for (let i = 0; i < this.socialHistroy.length; i++) {
          let filtersocial = this.socialHistroy[i]
          this.allsocialHistroy = this.filterDatlist.filter(item => item.helpDescription !== filtersocial);
        }
      } else {
        this.allsocialHistroy = data;
      }
      this.filterdata();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }
  filterdata() {
    this.filteredsocialHistroy = this.socialHistroyCtrl.valueChanges.pipe(
      startWith(null),
      map(socialData => (socialData ? this._filter(socialData) : this.allsocialHistroy.slice())),
    );

  }
  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('autocompleteTrigger') matACTrigger: MatAutocompleteTrigger;
  add(event: MatChipInputEvent): void {
    this.enabledisablebtn = false;
    const input = event.input;
    const value = (event.value || '').trim();

    if (this.socialHistroy.includes(value)) {
      input.value = '';
    } else {
      this.socialHistroy.push(value);
    }

    // Clear the input value
    if (input) {
      input.value = '';
    }
    this.socialHistroyCtrl.setValue(null);
  }

  remove(socialData: string): void {
   
    if (this.emrservice.socialhistoryPermission?.isDeletePermission == true) {
      const index = this.socialHistroy.indexOf(socialData);
      this.enabledisablebtn = false;
      if (index >= 0) {
        let addRemovelist = this.filterDatlist.filter(item1 => item1.helpDescription == socialData);
        let filterlist = this.allsocialHistroy.concat(addRemovelist);
        var result = filterlist.reduce((unique, o) => {
          if (!unique.some(obj => obj.pK_TranId === o.pK_TranId && obj.helpDescription === o.helpDescription)) {
            unique.push(o);
          }
          return unique;
        }, []);
        this.allsocialHistroy = result;
        this.socialHistroy.splice(index, 1);
      }
      this.filterdata();
    } else {
      this.dashboardService.openSnackBar("Delete permission denied", "OK");
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const newValue = event.option.viewValue;
    this.allsocialHistroy = this.allsocialHistroy.filter(item => item.helpDescription !== newValue);
    if (this.socialHistroy.includes(newValue)) {
      this.socialHistroy = [...this.socialHistroy.filter((fruit) => fruit !== newValue)];
      // this.allsocialHistroy.splice(this.allsocialHistroy, 1);
    } else {
      this.socialHistroy.push(event.option.viewValue);
    }
    this.fruitInput.nativeElement.value = '';
    this.socialHistroyCtrl.setValue(null);
    this.filterdata();
    requestAnimationFrame(() => {
      this.openAuto(this.matACTrigger);
    })
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allsocialHistroy.filter(socialData => socialData.helpDescription.toLowerCase().includes(filterValue));
  }

  openAuto(trigger: MatAutocompleteTrigger) {
    trigger.openPanel();
    this.fruitInput.nativeElement.focus();
    console.log(trigger);
  }

  save_otherinfo_toserver(name) {

    if (this.emrservice.otherinfo_history.pkTranId == undefined) {
      this.emrservice.otherinfo_history.pkTranId = 0;
    }
    this.emrservice.otherinfo_history.EntryHead = name;
    if (this.socialHistroy.length == 0 && this.emrservice.otherinfo_history.pkTranId == 0) {
      this.dashboardService.openSnackBar("Please Select The Habits", "Ok")
    } else {
      if (this.emrservice.otherinfo_history.pkTranId == 0) {
        let socialHistroy = this.socialHistroy.join(",");
        this.emrservice.otherinfo_history.socailHistory = socialHistroy;
        this.emrservice.save_other_info_history().pipe(takeUntil(this.destroysocial$)).subscribe(
          data => this.success_history_otherinfo(data), err => this.failed_history_otherinfo(err)
        )
      } else if (this.emrservice.otherinfo_history.pkTranId > 0 && this.emrservice.socialhistoryPermission?.isModifyPermission == true) {
        let socialHistroy = this.socialHistroy.join(",");
        this.emrservice.otherinfo_history.socailHistory = socialHistroy;
        this.emrservice.save_other_info_history().pipe(takeUntil(this.destroysocial$)).subscribe(
          data => this.success_history_otherinfo(data), err => this.failed_history_otherinfo(err)
        )
      } else {
        this.dashboardService.openSnackBar("Modify permission denied", "OK");
      }

    }

  }

  success_history_otherinfo(data) {
    this.enabledisablebtn = true;
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    this.get_otherinfo();
    this.emrservice.getHistoryStatus(this.emrservice.visitid);
    this.getSocialHistoryList();
  }

  failed_history_otherinfo(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  get_otherinfo() {
    this.emrservice.get_otherinfo().pipe(takeUntil(this.destroysocial$)).subscribe(
      data => this.success_otherinfo(data), err => this.failed_otherinfo(err)
    )
  }

  success_otherinfo(data) {
    this.emrservice.otherinfo_history = data;
    let getSocialHistorylist = this.emrservice.otherinfo_history.socailHistory;
    if (getSocialHistorylist != null) {
      let socialchipdata = getSocialHistorylist.split(',');
      this.socialHistroy = socialchipdata;
      this.selectedVal = this.socialHistroy;
    }
  }

  failed_otherinfo(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    this.emrservice.otherinfo_history = {};
  }



  socialHistory() {
    if (this.emrservice.socialhistoryPermission?.isAddPermission == true) {
      this.addhabitname = '';
    
      document.getElementById("socialHistoryModal").style.display = "block";
    } else {
      this.dashboardService.openSnackBar("Add permission denied", "OK");
    }
  }
  cancelsocialHistory() {
    document.getElementById("socialHistoryModal").style.display = "none";
  }

  addsocialHistory() {
    if (this.selectedVal == undefined || this.selectedVal == null || this.selectedVal.length == 0) {
      this.dashboardService.openSnackBar("Please Select The Habits", "Ok");
    } else {
      this.enabledisablebtn = false;
      this.socialHistroy = this.selectedVal;
      document.getElementById("socialHistoryModal").style.display = "none";
    }
  }

  addName(value) {

    this.addhabitname = '';
    let addname = value;
    if (addname != '') {
      const checkName = this.filterDatlist.filter(item => item.helpDescription.toLowerCase() == addname.toLowerCase());
      if (checkName.length == 0) {
        var payload = {
          "DynamicHelpList": {
            "pK_TranId": 0,
            "helpType": 'SocialHistory',
            "sequenceSetting": " ",
            "seqNo": 1,
            "helpDescription": addname,
            "isActive": true,
            "pK_SynchId": null,
            "isEdit": false,
            "isDelete": false
          }
        }
      } else {
        this.addhabitname = '';
        this.dashboardService.openSnackBar("Habit is already Existed", "OK");
      }
      this.emrservice.InsertDynamicHelpList(payload).pipe(takeUntil(this.destroysocial$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.addhabitname = '';
          this.getSocialHistoryList();
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      }, err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.dashboardService.openSnackBar("Please Enter The Habits", "Ok")
    }
  }

  onValChange(val, index) {
    this.selectedVal = val;
    this.filterDatlist[index].isActive = !this.filterDatlist[index].isActive
    // this.selectedVal.splice(index, 1);
  }

  ngOnDestroy(): void {
    this.destroysocial$.next(true);
    this.destroysocial$.unsubscribe();
    this.socialHistroy = null;
    this.filterDatlist = null;
    this.filteredsocialHistroy = null;
    this.allsocialHistroy = null;
    console.log("destory Social-history");
  }
}
